import { render, staticRenderFns } from "./PrivacyPolicy.vue?vue&type=template&id=deeb129a&scoped=true"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPolicy.vue?vue&type=style&index=0&id=deeb129a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deeb129a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('deeb129a')) {
      api.createRecord('deeb129a', component.options)
    } else {
      api.reload('deeb129a', component.options)
    }
    module.hot.accept("./PrivacyPolicy.vue?vue&type=template&id=deeb129a&scoped=true", function () {
      api.rerender('deeb129a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/P3_Page/Docs/kiko/PrivacyPolicy.vue"
export default component.exports